export default {
  addCard: {
    title: "Add New Bank Card",
    warning: "Please note, the card you register must be in your name.",
    inputLabel: "Card Number",
    button: "Verify and Add Card",
    verifyButton: "Verified",
    invalidCardNumber: "The entered card number is not valid."
  },
  notRegisteredCard: {
    title: "Not Verified",
    button: "Request Card Registration Again"
  },
  notRegisteredShebaCard: {
    title: "Not Verified",
    button: "Request Sheba Registration Again"
  },
  offlinePaymentNoticeCard: {
    title:
      "Please note, the deposit identifier is your national ID number. Be sure to write the deposit identifier on your bank receipt when making an offline deposit.",
    hideCheckbox: "Do not show this message again",
    button: "Got it"
  },
  userRegisteredCard: {
    title: "You have not registered any bank cards",
    description:
      "To deposit Rial, first register your bank card. Please note, for Rial deposits, only use the registered bank cards. Otherwise, your transaction will be suspended.",
    button: "Add Bank Card"
  },
  notAvailableCard: {
    title: "You have not registered any bank cards",
    description:
      "To deposit Rial, first register your bank card. Please note, for Rial deposits, only use the registered bank cards. Otherwise, your transaction will be suspended.",
    button: "Add Bank Card"
  },
  depositConfirmationCard: {
    desPartOne: "Please note, for Rial deposits ",
    desPartTwo: "only use the registered bank cards ",
    desPartThree: "Otherwise, your transaction will be suspended.",
    continueButton: "Got it, proceed to gateway",
    registeredCard: "Your Registered Cards",
    addCard: "Add New Card"
  },
  accountList: {
    title: "Excoino Account Numbers and Cards"
  },
  suggestionApps: {
    goToPWA: "Go to Web App Version",
    installGuide:
      "To add the Excoino web app to your mobile home screen, follow these steps:",
    shareTitle: "Tap the {n} button on the bottom bar",
    addToHomeTitle: "In the opened menu, at the bottom, select {n}.",
    addTitle: "In the next step, tap {n} at the top",
    confirmButton: "Got it"
  },
  expiredOrderCard: {
    title: "Order Completion Timeout",
    subtitle: "Your time to complete this order has expired",
    repeatOrderButton: "Repeat this order",
    goToWalletButton: "Return to Wallet Page"
  },
  cancelOrderCard: {
    title: "Cancel Order",
    subtitle: "Are you sure you want to cancel your order?",
    cancelOrderButton: "Yes, cancel it",
    goBackButton: "Cancel Cancellation"
  }
};
